
import { footerNav } from "@/api/footer";
export default {
  data() {
    return {
      footer: {},
      links: [], //底部链接
      plainText: [], ///底部文本
      wxcode: "",
    };
  },
  methods: {
    footerNav() {
      footerNav().then((res) => {
        if (res.data.code == 200) {
          this.footer = res.data.data;
          // console.log("res-data-data",res.data.data.plainText)
          res.data.data.plainText[0].children[0].title="公司名称：宁波启山智软科技有限公司"
          this.wxcode = this.footer.qrCode[0].wxcode;
          this.$store.commit("changeTel", res.data.data.telephone);
          this.$store.commit("changeWxcode", res.data.data.qrCode[0].wxcode);
        }
      });
    },
    changeicon(index) {
      this.wxcode = this.footer.qrCode[index].wxcode;
    },
  },
  mounted() {
    this.footerNav();
  },
};
